import React from "react";
import { Navigate, Route } from "react-router-dom";
import { UserRoleEnum } from "@/types/role.type";
import type { RouteCtx } from "../routeContext";
import { NotFound } from "../shell";
import {
  SiteFeasibilityPage,
  SiteActivation,
  CDAManagement,
  RBQMCenter,
  DocumentLibrary,
  UploadDocument,
  ETMFCompletenessDashboard,
} from "../lazyPages";

/** ctaRoutes — order preserved for React Router first-match. */
export function ctaRoutes(ctx: RouteCtx): React.ReactNode {
  const { userRole, hasRbqmAccess, currentStudy, selectedStudyId } = ctx;

  if (userRole !== UserRoleEnum.CTA) {
    return null;
  }

  return (
    <>
      <Route
        path="/cta/dashboard"
        element={<Navigate to="/dashboard" replace />}
      />
      <Route
        path="/cta/site-feasibility"
        element={
          <SiteFeasibilityPage
            userRole={userRole}
            currentStudy={currentStudy}
          />
        }
      />
      <Route
        path="/cta/site-activation"
        element={
          <SiteActivation userRole={userRole} currentStudy={currentStudy} />
        }
      />
      <Route
        path="/cta/rbqm-center"
        element={
          hasRbqmAccess ? (
            <RBQMCenter userRole={userRole} currentStudy={currentStudy} />
          ) : (
            <NotFound />
          )
        }
      />
      <Route
        path="/cta/cda-management"
        element={
          <CDAManagement userRole={userRole} currentStudy={currentStudy} />
        }
      />
      <Route
        path="/etmf/document-library"
        element={
          <DocumentLibrary
            userRole={userRole}
            selectedStudyId={selectedStudyId}
          />
        }
      />
      <Route
        path="/etmf/upload-document"
        element={
          <UploadDocument
            userRole={userRole}
            selectedStudyId={selectedStudyId}
            currentStudy={currentStudy ?? null}
          />
        }
      />
      <Route
        path="/etmf/completeness-dashboard"
        element={
          <ETMFCompletenessDashboard selectedStudyId={selectedStudyId} />
        }
      />
    </>
  );
}
